import { ReactNode, createContext, useContext, useMemo, useState } from "react";

export interface IDialogContext {
  openLoginDialog: boolean;
  openRegisterDialog: boolean;
  openAccountRecoveryDialog: boolean;
  openPasswordRecoveryDialog: boolean;
  openRegisterSuccessDialog: boolean;

  setOpenLoginDialog: Function;
  setOpenRegisterDialog: Function;
  setOpenAccountRecoveryDialog: Function;
  setOpenPasswordRecoveryDialog: Function;
  setOpenRegisterSuccessDialog: Function;
}

export const DialogContext = createContext<IDialogContext>(
  {} as IDialogContext
);

export function DialogProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const [openLoginDialog, setOpenLoginDialog] = useState<boolean>(false);
  const [openRegisterDialog, setOpenRegisterDialog] = useState<boolean>(false);
  const [openAccountRecoveryDialog, setOpenAccountRecoveryDialog] =
    useState<boolean>(false);
  const [openPasswordRecoveryDialog, setOpenPasswordRecoveryDialog] =
    useState<boolean>(false);
  const [openRegisterSuccessDialog, setOpenRegisterSuccessDialog] =
    useState<boolean>(false);

  const memoedValue = useMemo(
    () => ({
      openLoginDialog,
      openRegisterDialog,
      openAccountRecoveryDialog,
      openPasswordRecoveryDialog,
      openRegisterSuccessDialog,
      setOpenLoginDialog,
      setOpenRegisterDialog,
      setOpenAccountRecoveryDialog,
      setOpenPasswordRecoveryDialog,
      setOpenRegisterSuccessDialog,
    }),
    [
      openLoginDialog,
      openRegisterDialog,
      openAccountRecoveryDialog,
      openPasswordRecoveryDialog,
      openRegisterSuccessDialog,
    ]
  );

  return (
    <DialogContext.Provider value={memoedValue}>
      {children}
    </DialogContext.Provider>
  );
}

const useDialog = () => useContext(DialogContext);

export default useDialog;
